export const STYLE_FONT_BODY_LARGE_REGULAR =
  "var(--pl-font-body-large-regular)";
export const STYLE_FONT_BODY_LARGE_ACCENT = "var(--pl-font-body-large-accent)";
export const STYLE_FONT_TITLE_LARGE = "var(--pl-font-title-large)";
export const STYLE_FONT_TITLE_SMALL = "var(--pl-font-title-small)";
export const STYLE_COLOR_PRIMARY = "var(--pl-text-primary)";
export const STYLE_COLOR_INVERT_PRIMARY = "var(--pl-text-invert-primary)";

export const STYLE_SEARCH_INPUT = `--_f: ${STYLE_FONT_BODY_LARGE_REGULAR}; --_c: ${STYLE_COLOR_PRIMARY};`;
export const STYLE_CLUSTER_ICON = `--_f: ${STYLE_FONT_TITLE_LARGE}; --_c: ${STYLE_COLOR_PRIMARY};`;
export const STYLE_BALLOON_CONTENT_TITLE = `--_f: ${STYLE_FONT_TITLE_SMALL}; --_c: ${STYLE_COLOR_PRIMARY};`;
export const STYLE_BALLOON_CONTENT_DETAILS = `--_f: ${STYLE_FONT_BODY_LARGE_REGULAR}; --_c: ${STYLE_COLOR_PRIMARY};`;
export const STYLE_BALLOON_CONTENT_BUTTON = `--_f: ${STYLE_FONT_BODY_LARGE_ACCENT}; --_c: ${STYLE_COLOR_INVERT_PRIMARY};`;
